import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';

class View extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.BLANK)
            return null;

        return (
            <div>
                Nenhuma permissão para o seu usuário.
            </div>
        );
    }
}

export default View;


// WEBPACK FOOTER //
// src/views/pages/Blank.jsx